import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin, NestingLevelMixin, Tools} from '../common/common.js';
import Environment from '../environment/environment.js';
import Link from './link.js';
import Glyphicon from './glyphicon.js'
import Span from './span.js';

import './dropdown-item.less'

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Dropdown.Item',
    nestingLevelList: Environment.getNestingLevelList('smallBoxCollection'),
    classNames: {
      main: 'uu5-bricks-dropdown-item',
      link: 'uu5-bricks-dropdown-item-link',
      divider: 'divider',
      header: 'dropdown-header',
      subMenu: 'uu5-bricks-dropdown-submenu uu5-bricks-dropdown-menu dropdown-menu',
      subMenuItem: 'uu5-bricks-dropdown-item-submenu',
      dropup: 'uu5-bricks-dropdown-item-submenu-dropup',
      disabledItem: 'disabled'
    },
    defaults: {
      childTagName: 'UU5.Bricks.Dropdown.Item'
    },
    errors: {
      maxLevel: 'Max submenu level is 3!'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    header: React.PropTypes.bool,
    divider: React.PropTypes.bool,
    label: React.PropTypes.any, // content
    href: React.PropTypes.string,
    onClick: React.PropTypes.func,
    smoothScroll: React.PropTypes.number,
    offset: React.PropTypes.number,
    target: React.PropTypes.string,
    dropup: React.PropTypes.bool
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps() {
    return {
      header: false,
      divider: false,
      label: null,
      href: null,
      onClick: null,
      smoothScroll: null,
      offset: null,
      target: '_self',
      dropup: false
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  expandChildProps_(child) {
    let newChildProps = Tools.mergeDeep({}, child.props);

    newChildProps.dropup = newChildProps.dropup || this.props.dropup;

    return newChildProps;
  },
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _onClickHandler() {
    var parent = this.getParentByType('isDropdown');
    parent && parent.close();
    return this;
  },

  _getStandardItem(props) {
    let linkProps = {
      className: this.getClassName().link,
      content: this.props.label,
      parent: this,
      disabled: this.isDisabled()
    };

    if (!this.isDisabled()) {
      linkProps.onClick = this.props.onClick;
      linkProps.href = this.props.href;
      linkProps.smoothScroll = this.props.smoothScroll;
      linkProps.offset = this.props.offset;
      linkProps.target = this.props.target;

      props.onClick = this._onClickHandler;
    }

    return (
      <li {...props}>
        <Link {...linkProps} />
      </li>
    );
  },

  _getDividerItem(props) {
    props.className += ' ' + this.getClassName().divider;
    return <li {...props} />;
  },

  _getHeaderItem(props) {
    props.className += ' ' + this.getClassName().header;
    return (
      <li {...props}>
        <Span content={this.props.label} />
      </li>
    );
  },

  _getContentItem(props) {
    return (
      <li {...props}>{this.getChildren()}</li>
    );
  },

  _getSubMenuItem (props) {
    let linkProps = {
      className: this.getClassName().link,
      parent: this,
      disabled: this.isDisabled()
    };

    if (!this.isDisabled()) {
      linkProps.onClick = this.props.onClick;
      linkProps.href = this.props.href;
      linkProps.smoothScroll = this.props.smoothScroll;
      linkProps.offset = this.props.offset;
      linkProps.target = this.props.target;

      this.props.onClick && (props.onClick = this._onClickHandler);
      props.className += ' ' + this.getClassName().subMenuItem;
    }

    if (this.getParent() !== null && this.getParent().getParent() !== null && this.getParent().getParent().getParent() !== null) {
      if (this.getParent().getParent().getParent().getTagName() === 'UU5.Bricks.Dropdown') {
        this.showError('maxLevel');
        return (
          <li {...props} >
            <Link {...linkProps} content={this.props.label} />
          </li>
        );
      }
    }

    return (
      <li {...props} >
        <Link {...linkProps} >
          {this.props.label}
          <Glyphicon glyphicon='uu-glyphicon-arrow-right' />
        </Link>

        <ul className={this.getClassName().subMenu + (this.props.dropup ? ' ' + this.getClassName().dropup : '')}>
          {this._getChildren()}
        </ul>
      </li>
    );
  },

  _getChildren() {
    var contentProps = {};

    if (this.props.items) {
      contentProps = {
        content: {
          tag: this.getDefault().childTagName,
          propsArray: this.props.items
        }
      };
    } else if (this.props.children) {
      contentProps = { children: this.props.children };
    }
    contentProps.nestingLevel = this.getNestingLevel();

    return this.buildChildren(contentProps);
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render() {
    let mainAttrs = this.buildMainAttrs();

    if (this.isDisabled()) {
      mainAttrs.className += ' ' + this.getClassName().disabledItem;
    }

    let result = null;

    if (this.getNestingLevel()) {
      if (this.getChildren() !== null) {
        result = this._getSubMenuItem(mainAttrs);
      } else {
        if (this.getContent() || this.props.children) {
          result = this._getContentItem(mainAttrs);
        } else if (this.props.divider) {
          result = this._getDividerItem(mainAttrs);
        } else if (this.props.header) {
          result = this._getHeaderItem(mainAttrs);
        } else {
          result = this._getStandardItem(mainAttrs);
        }
      }
    }

    return result;
  }
  //@@viewOff:render
});



// WEBPACK FOOTER //
// ./bricks/dropdown-item.js